import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./Breadcrumb";
import { Link } from "react-router-dom";
import { HOME } from "../../lib/routesResolver";
import { useTranslation } from "react-i18next";
import React from "react";

const BreadcrumbPanel = ({ items }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={HOME}>{t("defaults.breadcrumbFirstItem")}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        {items &&
          items.map((item, index, arr) => {
            if (index + 1 === arr.length) {
              return (
                <BreadcrumbItem key="final_breadcrumb_item">
                  <BreadcrumbPage>
                    {t(item.title, item?.titleOptions)}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              );
            } else {
              return (
                <React.Fragment key={`breadcrum_item_${index}`}>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to={item.link}>
                        {t(item.title, item?.titleOptions)}
                      </Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator />
                </React.Fragment>
              );
            }
          })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadcrumbPanel;
